// Studie niveaus en jaren data
export const STUDIE_NIVEAUS = {
  'MBO': {
    niveaus: ['Niveau 1', 'Niveau 2', 'Niveau 3', 'Niveau 4'],
    jaren: ['Jaar 1', 'Jaar 2', 'Jaar 3', 'Jaar 4']
  },
  'HBO': {
    categorieen: ['HBO Bachelor', 'HBO Associate Degree', 'HBO Master'],
    jaren: {
      'HBO Bachelor': ['Jaar 1', 'Jaar 2', 'Jaar 3', 'Jaar 4'],
      'HBO Associate Degree': ['Jaar 1', 'Jaar 2'],
      'HBO Master': ['Jaar 1', 'Jaar 2']
    }
  },
  'Universiteit': {
    categorieen: ['Universiteit Bachelor', 'Universiteit Master'],
    jaren: {
      'Universiteit Bachelor': ['Jaar 1', 'Jaar 2', 'Jaar 3'],
      'Universiteit Master': ['Jaar 1', 'Jaar 2']
    }
  }
};

// MBO Niveau 1 specifieke studies
export const MBO_NIVEAU_1_STUDIES = [
  'Assistent Horeca',
  'Assistent Zorg en Welzijn',
  'Assistent Retail',
  'Assistent Techniek',
  'Assistent Administratie'
];

// MBO Niveau 2 specifieke studies met categorieën en subcategorieën
export const MBO_NIVEAU_2_STUDIES = {
  'Bouw & Afwerking': {
    'Ruwbouw': [
      'Metselaar',
      'Betontimmerman',
      'Betonstaalvlechter',
      'Aankomend medewerker grondoptreden',
      'Tegelzetter',
      'Waterbouwer',
      'Vakman GWW',
      'Opperman bestratingen'
    ],
    'Afwerking & Interieur': [
      'Timmerman',
      'Meubelmaker / (scheeps)interieurbouwer',
      'Interieurvakman parketvloeren',
      'Interieurvakman woningstofferen',
      'Keukenmonteur',
      'Stukadoor',
      'Glaszetter',
      'Voeger',
      'Schilder',
      'Dekvloerenlegger',
      'Natuursteenbewerker ambachtelijk',
      'Natuursteenbewerker machinaal',
      'Monteur metalen daken en gevels',
      'Dakdekker bitumen en kunststof',
      'Dakdekker riet'
    ],
    'Montage & Plaatsing': [
      'Montagemedewerker houttechniek',
      'Carrosseriebouwer'
    ]
  },
  'Techniek & Installatie': {
    'Werktuigbouw / Klimaat': [
      'Monteur koude- en klimaatsystemen',
      'Monteur gas-, water- of warmtedistributie',
      'Monteur werktuigkundige installaties',
      'Airco/warmtepompmonteur',
      'Monteur service en onderhoud installaties en systemen',
      'Verbrandingsmotortechnicus'
    ],
    'Elektrotechniek & Mechatronica': [
      'Monteur elektrotechnische installaties',
      'Monteur middenspanningsdistributie',
      'Monteur laagspanningsdistributie',
      'Monteur datadistributie',
      'Monteur mechatronica',
      'Machineoperator houttechniek'
    ],
    'Luchtvaart / Maritiem / Voertuigen': [
      'Monteur luchtvaartuigen',
      'Basis technicus voertuigen en mobiele werktuigen',
      'Autoschadehersteller',
      'Stuurman werktuigkundige zeevisvaart sw6'
    ]
  },
  'Logistiek & Transport': {
    'Transport & Rijden': [
      'Chauffeur wegvervoer',
      'Chauffeur openbaar vervoer',
      'Touringcarchauffeur',
      'Taxichauffeur'
    ],
    'Logistiek & Opslag': [
      'Logistiek medewerker',
      'Medewerker internationale havenlogistiek',
      'Medewerker havenoperaties',
      'Medewerker agrohandel en logistiek'
    ]
  },
  'Productie & Industrie': {
    'Technische productie': [
      'Industrieel lakverwerker',
      'Medewerker productietechniek',
      'Medewerker operationele techniek',
      'Medewerker voeding, technologie en techniek',
      'Medewerker versindustrie',
      'Allround medewerker afvalbeheer'
    ],
    'Voeding & Bakkerij': [
      'Kok',
      'Uitvoerend bakker',
      'Medewerker vers'
    ],
    'Drukwerk / Media / Sign': [
      'Basismedewerker printmedia',
      'Medewerker sign'
    ]
  },
  'ICT & Creatieve Media': {
    'ICT & Media': [
      'Medewerker ICT',
      'Mediamaker',
      'Medewerker fotografie',
      'Medewerker podium- en evenemententechniek'
    ]
  },
  'Dienstverlening & Zorg': {
    'Zorg & Welzijn': [
      'Helpende zorg en welzijn'
    ],
    'Beveiliging & Faciliteiten': [
      'Beveiliger 2',
      'Medewerker facilitaire dienstverlening',
      'Servicemedewerker gebouwen',
      'Gastheer/-vrouw',
      'Schoonmaker in verschillende omgevingen',
      'Meewerkend leidinggevende algemeen schoonmaakonderhoud',
      'Schoenhersteller'
    ]
  },
  'Groen, Dier & Milieu': {
    'Groen & Natuur': [
      'Medewerker hovenier',
      'Medewerker natuur, water en recreatie',
      'Medewerker groen, grond en groene infra'
    ],
    'Dier & Landbouw': [
      'Medewerker dierverzorging',
      'Medewerker teelt',
      'Medewerker veehouderij'
    ]
  },
  'Handel, Retail & Verkoop': {
    'Retail & Verkoop': [
      'Retailmedewerker',
      'Verkoopmedewerker optiek',
      'Medewerker productpresentatie',
      'Medewerker bloem, groen en styling'
    ]
  },
  'Mode & Fashion': {
    'Mode': [
      'Basismedewerker fashion'
    ]
  },
  'Scheepvaart & Binnenvaart': {
    'Maritiem': [
      'Schipper-machinist beperkt werkgebied',
      'Schipper rondvaartboot beperkt vaargebied',
      'Matroos binnenvaart',
      'Aankomend medewerker maritiem'
    ]
  }
};

// MBO Niveau 3 specifieke studies met categorieën en subcategorieën
export const MBO_NIVEAU_3_STUDIES = {
  'Techniek, Bouw & Productie': {
    'Werktuigbouw & Elektrotechniek': [
      'Eerste monteur datadistributie',
      'Eerste monteur middenspanningsdistributie',
      'Eerste monteur laagspanningsdistributie',
      'Eerste monteur gas-, water- of warmtedistributie',
      'Eerste monteur elektrotechnische installaties woning en utiliteit',
      'Eerste monteur elektrotechnische industriële installaties en systemen',
      'Eerste monteur service en onderhoud werktuigkundige installaties',
      'Eerste monteur service en onderhoud elektrotechniek en instrumentatie',
      'Eerste monteur koude- en klimaatsystemen',
      'Tekenaar werktuigbouw'
    ],
    'Bouw & Infrastructuur': [
      'Allround metselaar',
      'Allround betonstaalverwerker bouwplaats',
      'Machinist hijswerk',
      'Machinist wegenbouw',
      'Allround dakdekker metaal',
      'Allround dakdekker bitumen en kunststof',
      'Straatmaker',
      'Gezel glaszetter',
      'Eerste monteur utiliteit',
      'Allround betontimmerman',
      'Allround betonreparateur',
      'Allround vakkracht onderhoud- en klussenbedrijf'
    ],
    'Mechatronica & Automatisering': [
      'Eerste monteur mechatronica',
      'Allround technicus voertuigen en mobiele werktuigen',
      'Eerste verbrandingsmotortechnicus',
      'Allround uurwerktechnicus',
      'Allround laborant'
    ],
    'Houtbewerking & Meubelindustrie': [
      'Allround machineoperator houttechniek',
      'Allround machineoperator meubelindustrie / (scheeps)interieurbouw',
      'Allround meubelmaker / (scheeps)interieurbouwer'
    ]
  },
  'Zorg, Welzijn & Dieren': {
    'Gezondheidszorg': [
      'Verzorgende IG',
      'Medewerker steriele medische hulpmiddelen',
      'Pedicure',
      'Orthopedisch schoentechnisch medewerker',
      'Tandtechnisch medewerker basistechnieken'
    ],
    'Maatschappelijke Zorg & Opvang': [
      'Begeleider maatschappelijke zorg',
      'Pedagogisch medewerker kinderopvang',
      'Werkbegeleider zorgboerderij'
    ],
    'Dierverzorging': [
      'Zelfstandig medewerker dierverzorging',
      'Proefdierverzorger'
    ]
  },
  'Veiligheid, Defensie & Toezicht': {
    'Toezicht & Handhaving': [
      'Handhaver toezicht en veiligheid openbaar vervoer (domein IV)',
      'Handhaver toezicht en veiligheid openbare ruimte (domein I)',
      'Handhaver toezicht en veiligheid milieu, welzijn en infrastructuur (domein II)',
      'Handhaver toezicht en veiligheid generieke opsporing (domein VI)'
    ],
    'Defensie & Maritiem': [
      'Aankomend onderofficier maritiem',
      'Aankomend onderofficier grondoptreden'
    ],
    'Havenveiligheid': [
      'Beveiliger 3',
      'Voorman BOR',
      'Balkman',
      'Bootman'
    ]
  },
  'Commercieel, Zakelijk & Mode': {
    'Retail & Verkoop': [
      'Commercieel medewerker',
      'Retailspecialist',
      'Fashion retailer',
      'Assistant fashion tailor'
    ],
    'Horeca & Gastvrijheid': [
      'Zelfstandig werkend gastheer/-vrouw',
      'Zelfstandig werkend kok',
      'Eerste medewerker fastservice'
    ],
    'Administratie & Bedrijfsondersteuning': [
      'Allround assistant business services',
      'Logistiek teamleider',
      'Coördinator internationale havenlogistiek'
    ],
    'Creatieve Ambachten': [
      'Basisgoudsmid'
    ]
  },
  'Vervoer, Transport & Maritiem': {
    'Scheepvaart & Maritiem': [
      'Schipper binnenvaart',
      'Maritiem officier kleine schepen technisch',
      'Maritiem officier kleine schepen nautisch, visserij',
      'Maritiem officier kleine schepen nautisch, koopvaardij'
    ],
    'Weg- & Personenvervoer': [
      'Touringcarchauffeur/reisleider'
    ]
  },
  'Groen, Agrarisch & Landschap': {
    'Tuinbouw & Natuur': [
      'Vakbekwaam medewerker teelt',
      'Vakbekwaam medewerker natuur, water en recreatie',
      'Vakbekwaam medewerker groen, grond en groene infra',
      'Vakbekwaam medewerker bloem, groen en styling'
    ],
    'Veeteelt': [
      'Vakbekwaam medewerker veehouderij'
    ],
    'Hoveniers & Groenvoorziening': [
      'Vakbekwaam hovenier'
    ]
  },
  'Creatieve & Vormgevende Technieken': {
    'Interieur & Meubel': [
      'Allround meubelmaker / (scheeps)interieurbouwer',
      'Allround meubelstoffeerder',
      'Allround interieurvakman parketvloeren',
      'Allround interieurvakman woningstofferen'
    ],
    'Visuele Vormgeving': [
      'Allround signmaker',
      'Allround stand- en decorbouwer'
    ],
    'Technisch Onderhoud & Reparatie': [
      'Gezel schilder',
      'Eerste monteur dakbedekking'
    ],
    'Voertuigentechniek': [
      'Eerste autospuiter'
    ]
  },
  'Logistiek & Productie': {
    'Productieprocessen': [
      'Allround medewerker productietechniek',
      'Procesoperator B'
    ],
    'Logistiek & Distributie': [
      'Logistiek teamleider',
      'Coördinator internationale havenlogistiek'
    ]
  },
  'Media, IT & Ondersteuning': {
    'Media & Vormgeving': [
      'Allround mediamaker',
      'Allround medewerker AV-productie'
    ],
    'IT & Systeemonderhoud': [
      'Allround medewerker IT systems and devices'
    ]
  },
  'Voeding & Vers': {
    'Voeding & Vers': [
      'Allround medewerker versindustrie'
    ]
  }
};

// MBO Niveau 4 specifieke studies met categorieën en subcategorieën
export const MBO_NIVEAU_4_STUDIES = {
  'Gezondheidszorg en Welzijn': {
    'Zorg & Begeleiding': [
      'Mbo-Verpleegkundige',
      'Verzorgende IG (Individuele Gezondheidszorg)',
      'Persoonlijk begeleider maatschappelijke zorg',
      'Sociaal Pedagogisch Hulpverlener (SPH)',
      'Jeugdzorgwerker',
      'Leefstijlcoach',
      'Voeding- en leefstijladviseur',
      'Medisch Secretaresse',
      'Manager Gezondheidszorg',
      'Persoonlijk werkbegeleider zorgboerderij'
    ],
    'Assistenten & Paramedici': [
      'Doktersassistent',
      'Apothekersassistent',
      'Tandartsassistent',
      'Technisch oogheelkundig assistent',
      'Orthopedisch technisch specialist',
      'Tandtechnicus prothese',
      'Medisch pedicure'
    ],
    'Dieren & Paardensport': [
      'Dierenartsassistent paraveterinair',
      'Instructeur paardensport en -houderij'
    ]
  },
  'Techniek en Engineering': {
    'Elektrotechniek & Mechatronica': [
      'Technicus elektrotechniek',
      'Technicus data',
      'Technicus mechatronica',
      'Technicus elektrotechnische industriële systemen en installaties',
      'Technicus elektrotechnische installaties in de gebouwde omgeving',
      'Technicus service en onderhoud elektrotechniek en instrumentatie'
    ],
    'Werktuigbouw & Mechanica': [
      'Technicus service en onderhoud werktuigbouw',
      'Technicus service en onderhoud werktuigkundige installaties',
      'Technicus mechanica luchtvaartuigen',
      'Technicus industriële koude- en klimaatsystemen',
      'Onderhoudsmonteur',
      'Installatiemonteur',
      'Junior Technisch Tekenaar'
    ],
    'Voertuigen & Luchtvaart': [
      'Technicus avionica luchtvaartuigen',
      'Technisch specialist voertuigen en mobiele werktuigen',
      'Technisch specialist autoschadeherstel',
      'Technisch specialist verbrandingsmotoren'
    ],
    'Water & Gas': [
      'Technicus gas',
      'Technicus water'
    ],
    'Engineering & Ontwerp': [
      'Technicus engineering',
      'Technisch leidinggevende'
    ]
  },
  'Onderwijs en Coaching': {
    'Docenten & Begeleiders': [
      'Onderwijsassistent',
      'Praktijkopleider',
      'Vakdocent',
      'Pedagogisch Werker',
      'Trainer-coach/Instructeur',
      'Instructeur mbo'
    ],
    'Sport & Beweging': [
      'Buurtsportcoach',
      'Bewegingsagoog'
    ],
    'Duurzaamheid & Maatschappij': [
      'Coördinator duurzaamheid'
    ]
  },
  'Ondernemerschap en Bedrijfskunde': {
    'Management & Leiding': [
      'Manager mobiliteitsbranche',
      'Manager/bedrijfsleider fastservice',
      'Manager/ondernemer horeca',
      'Manager/bedrijfsleider bloem, groen en styling',
      'Bedrijfsleider dierverzorging',
      'Bedrijfsleider paardensport en -houderij',
      'Bedrijfsleider/ondernemer bloem, groen en styling',
      'Business administration & control specialist',
      'Commercieel Manager',
      'Projectleider Bedrijfskunde'
    ],
    'Commercieel & Verkoop': [
      'Junior accountmanager',
      'Retailmanager',
      'Junior manager groothandel',
      'Junior manager internationale handel',
      'E-commerce Specialist',
      'Interieuradviseur'
    ],
    'Zelfstandig Ondernemerschap': [
      'Vakspecialist ondernemer',
      'Ondernemer handel',
      'Ondernemer bakkerij',
      'Ondernemer vers',
      'Ondernemerhandel',
      'Meewerkend horeca ondernemer',
      'Ondernemend meubelmaker / (scheeps)interieurbouwer',
      'Zelfstandig Ondernemer'
    ]
  },
  'Media, Communicatie en Marketing': {
    'Media & Creatie': [
      'Mediamanager',
      'Mediaredactiemedewerker',
      'Mediavormgever'
    ],
    'Marketing & Communicatie': [
      'Marketing & communication specialist',
      'Communicatieadviseur',
      'Public Relations Specialist',
      'Content Manager',
      'E-commerce specialist'
    ]
  },
  'Creatieve en Technische Sectoren': {
    'Groen, Bloem & Styling': [
      'Vakexpert bloem, groen en styling',
      'Vakexpert groen, grond en groene infra'
    ],
    'Vormgeving & Ambacht': [
      'Ruimtelijk vormgever',
      'Signspecialist',
      'Decoratie- en restauratieschilder',
      'Zilversmid',
      'Goudsmid',
      'Creatief vakman'
    ],
    'Voeding & Technologie': [
      'Vakexpert voeding, kwaliteit en productontwikkeling',
      'Vakexpert voeding, technologie en techniek'
    ],
    'Geo & Design': [
      'Vakexpert geo, data & design'
    ],
    'Agrarisch & Agro': [
      'Vakexpert biologisch-dynamische landbouw',
      'Vakexpert teelt en groene technologie',
      'Vakexpert agrohandel en logistiek'
    ],
    'Mode & Styling': [
      'Allround make-up and hair artist',
      'Fashion tailor',
      'Fashion designer',
      'Fashion product coördinator',
      'Interieuradviseur'
    ]
  },
  'Technische Specialismen': {
    'Klimaat & Koudetechniek': [
      'Systeemontwerper koude- en klimaatsystemen'
    ],
    'Engineering & Techniek': [
      'Commercieel technicus engineering',
      'Software developer'
    ],
    'Voertuigentechniek': [
      'Technisch specialist autoschadeherstel',
      'Technisch specialist voertuigen en mobiele werktuigen',
      'Technisch specialist verbrandingsmotoren',
      'Technisch specialist elektrotechniek'
    ],
    'Tekenwerk & Voorbereiding': [
      'Tekenaar ontwerper elektrotechniek',
      'Tekenaar ontwerper werktuigkundige installaties',
      'Tekenaar constructeur',
      'Werkvoorbereider installaties',
      'Werkvoorbereider gespecialiseerde aannemerij',
      'Werkvoorbereider houttechniek',
      'Werkvoorbereider meubelindustrie / (scheeps)interieurbouw',
      'Werkvoorbereider fabricage'
    ]
  },
  'Bouw en Infra': {
    'Uitvoering & Coördinatie': [
      'Uitvoerder bouw/infra',
      'Uitvoerder',
      'Uitvoerder gespecialiseerde aannemerij',
      'Coördinator havenoperaties',
      'Coördinator duurzaamheid',
      'Opzichter/uitvoerder groene ruimte'
    ],
    'Restauratie & Afwerking': [
      'Decoratiestukadoor',
      'Specialist restauratie timmerwerk',
      'Specialist restauratie metselwerk',
      'Specialist restauratie schilderwerk'
    ],
    'Middenkader Bouw & Infra': [
      'Middenkaderfunctionaris verkeer en stedenbouw',
      'Middenkaderfunctionaris landmeetkunde',
      'Middenkaderfunctionaris grond-, weg- en waterbouw',
      'Middenkaderfunctionaris bouw',
      'Middenkaderfunctionaris smart building'
    ]
  },
  'Logistiek en Transport': {
    'Logistiek & Distributie': [
      'Logistiek supervisor',
      'Transport en logistiek',
      'Specialist internationale havenlogistiek'
    ],
    'Luchtvaart & Maritiem': [
      'Air cargo specialist',
      'Luchtvaartdienstverlener',
      'Aviation operations specialist',
      'Kapitein binnenvaart',
      'Maritiem officier alle schepen nautisch, visserij',
      'Maritiem officier alle schepen nautisch, waterbouw',
      'Maritiem officier alle schepen nautisch, koopvaardij'
    ]
  },
  'Mode en Styling': {
    'Modeontwerp & Productie': [
      'Fashion tailor',
      'Fashion product coördinator',
      'Fashion designer'
    ],
    'Podium & Evenement': [
      'Allround podium- en evenemententechnicus'
    ],
    'Kappers & Salons': [
      'Salonmanager dame',
      'Salonmanager heer'
    ]
  }
};

// HBO Bachelor specifieke studies met categorieën en subcategorieën
export const HBO_BACHELOR_STUDIES = {
  'Economie & Bedrijfskunde': {
    'Financiën & Accountancy': [
      'Accountancy',
      'Finance & Control',
      'Finance, Tax and Advice',
      'International Financial Management en Control',
      'Master of Financial Management and Control',
      'Social Financiële Dienstverlening'
    ],
    'Bedrijfskunde & Management': [
      'Bedrijfskunde',
      'Business Administration',
      'Ondernemerschap en Retail Management',
      'Risicomanagement',
      'Vastgoedkunde'
    ],
    'Marketing & Commercie': [
      'Commerciële Economie',
      'E-Commerce',
      'Online Marketing',
      'Sales en Accountmanagement',
      'Crossmediale communicatie'
    ]
  },
  'Management & Organisatie': {
    'Algemeen Management': [
      'Management en Organisatie',
      'Business Administration',
      'Master Begeleidingskunde',
      'Master Management en Innovatie in Maatschappelijke Organisaties'
    ],
    'Ondernemerschap & Innovatie': [
      'Business Innovation (EN)',
      'Creative Business',
      'Ondernemerschap Retail and Management'
    ],
    'Human Resource & Coaching': [
      'Human Resource Management',
      'Organisatiecoaching'
    ],
    'Facility & Veiligheid': [
      'Facility Management',
      'Facilitair Eventmanagement',
      'Integrale Bedrijfsvoering',
      'Integrale Veiligheidskunde',
      'Safety and Security Management Studies'
    ],
    'Internationaal & Logistiek': [
      'AMSIB - International Business',
      'European Studies',
      'Shipping and Transport'
    ]
  },
  'Techniek & ICT': {
    'Engineering & Technologie': [
      // Automotive
      'Automotive',
      'Automotive Engineering',
      'Maritiem Officier',
      // Biomedical
      'Biomedische Technologie',
      'Mens en Techniek',
      // Civil
      'Built Environment',
      'Civiele Techniek',
      'Stedenbouw',
      'Ruimtelijke Ontwikkeling',
      // Chemical
      'Chemische Technologie',
      'Process en Food Technology',
      // Electrical
      'Elektrotechniek',
      'Engineering: Elektrotechniek',
      'Smart Technology',
      // General
      'Engineering',
      'Engineering: Technische Bedrijfskunde',
      'Engineering: Werktuigbouwkunde',
      'Next Level Engineering',
      // Industrial
      'Industrial Design Engineering',
      'Industrial Engineering and Management',
      'Mechatronica',
      // Math/Physics
      'Technische Natuurkunde',
      'Toegepaste Wiskunde',
      // Design
      'Engineering: Product Ontwerpen',
      // AI
      'Artificial Intelligence'
    ],
    'Informatica & Cybersecurity': [
      'Cyber Security Engineering',
      'Cybersecurity',
      'HBO-ICT',
      'Informatica',
      'Information Security',
      'Information Technology',
      'IT Service Management',
      'Artificial Intelligence'
    ],
    'Supply Chain & Bouwmanagement': [
      'Integraal Bouwmanagement',
      'International Supply Chain Management',
      'Logistics Engineering',
      'Logistics Management',
      'Maintenance'
    ],
    'Luchtvaart & Transport': [
      'Aviation',
      'Luchtvaarttechnologie'
    ]
  },
  'Gezondheid & Zorg': {
    'Medische Zorg & Therapie': [
      'Ergotherapie',
      'Ergotherapie: Leerroute IPZ',
      'Fysiotherapie',
      'Fysiotherapie: Leerroute IPZ',
      'Huidtherapie',
      'Physician Assistant',
      'Podotherapie',
      'Verloskunde'
    ],
    'Gezondheid & Voeding': [
      'Advanced Health Informatics Practice',
      'Food Commerce & Technology',
      'Gezondheid',
      'Management in de Zorg',
      'Medical Imaging and Radiation Therapy',
      'Voeding en Diëtetiek'
    ],
    'Sociale & Psychische Zorg': [
      'Interprofessionele Paramedische Zorg',
      'Oefentherapie: Leerroute IPZ',
      'Social Work',
      'Toegepaste Psychologie'
    ]
  },
  'Recht & Bestuur': {
    'Bestuur & Beleidsvorming': [
      'Bestuurskunde',
      'European Studies',
      'International Public Policy and Leadership'
    ],
    'Juridische Studies': [
      'Forensisch Onderzoek',
      'HBO-Rechten',
      'Sociaal Juridische Dienstverlening/Expert'
    ]
  },
  'Onderwijs & Opvoeding': {
    'Lerarenopleiding - Algemeen': [
      'Kopopleiding Tweedegraadsleraar',
      'Leraar Aardrijkskunde',
      'Leraar Biologie',
      'Leraar Duits',
      'Leraar Economie',
      'Leraar Engels',
      'Leraar Frans',
      'Leraar Geschiedenis',
      'Leraar Gezondheidszorg en Welzijn',
      'Leraar Horeca en Voeding',
      'Leraar Maatschappijleer',
      'Leraar Natuurkunde',
      'Leraar Nederlands',
      'Leraar Omgangskunde',
      'Leraar Pedagogiek',
      'Leraar Scheikunde',
      'Leraar Spaans',
      'Leraar Technisch Beroepsonderwijs',
      'Leraar Wiskunde'
    ],
    'Lerarenopleiding - Specifieke Richtingen': [
      'Academie/Leraar voor Lichamelijke Opvoeding (ALO)',
      'Docent Beeldende Kunst en Vormgeving',
      'Docent Theater',
      'Educatief Professional Beroepsonderwijs',
      'Pabo',
      'Pabo-ALO (Leraar Basisonderwijs)',
      'Pedagogiek',
      'Pedagogisch Educatief Professional',
      'Universitaire Pabo'
    ],
    'Onderwijs & Innovatie': [
      'Educational Leadership',
      'Leren Innoveren',
      'Logopedie',
      'Master Jonge Kind',
      'Taalbewust Leren'
    ]
  },
  'Media, Communicatie & Creativiteit': {
    'Communicatie & Journalistiek': [
      'Communicatie',
      'Communication and Multimedia Design',
      'International Communication Management',
      'Journalistiek'
    ],
    'Design & Creatieve Sector': [
      'AMFI - Amsterdam Fashion Institute',
      'Circus and Performance Art',
      'Crossmediale Communicatie',
      'Design – Art, Communication and Design',
      'Electronic Music',
      'Master Design'
    ],
    'Marketing & Sales': [
      'Marketing Management',
      'Sales en Accountmanagement'
    ]
  },
  'Sport & Bewegen': {
    'Sportonderwijs & Coaching': [
      'Academie/Leraar voor Lichamelijke Opvoeding (ALO)',
      'Lesgeven in Sport en Bewegen',
      'Sport Studies',
      'Sportkunde'
    ],
    'Sportmanagement & Marketing': [
      'Johan Cruyff Academy',
      'SPECO Sportcommunicatie',
      'SPECO Sportmarketing'
    ]
  }
};

// HBO Associate Degree specifieke studies met categorieën en subcategorieën
export const HBO_ASSOCIATE_DEGREE_STUDIES = {
  'Economisch en Bedrijf': {
    'Bedrijfskunde & Management': [
      'Bedrijfskunde',
      'Business Administration',
      'Management',
      'Technische Bedrijfskunde',
      'Technische Bedrijfskunde & IT',
      'International Business',
      'International Business Management',
      'Sustainability',
      'Ondernemerschap & Retail Management',
      'Ondernemen',
      'Business School Notenboom',
      'Bedrijfskunde en Agribusiness'
    ],
    'Finance & Accountancy': [
      'Accountancy',
      'Finance',
      'Finance & Control',
      'Financieel Management',
      'Sociaal Financiële Dienstverlening',
      'Payroll Services'
    ],
    'Marketing & Communicatie': [
      'Online Marketing',
      'Marketing Management',
      'Commerciële Economie',
      'Commerciële Economie & Ondernemerschap',
      'E-commerce',
      'Commercieel Management',
      'Communicatie',
      'Smart Media Production',
      'Online Contentcreator',
      'Crossmediale Communicatie',
      'Creative Media Professional',
      'Digitale Techniek & Media',
      'Media Design'
    ],
    'Hospitality, Horeca & Toerisme': [
      'Horeca Management',
      'Hotel Management',
      'International Hospitality Management',
      'Hotel & Event Management',
      'Tourism Management',
      'Internationaal Toeristisch Management',
      'Leisure & Event Management',
      'Leisure & Events Management'
    ],
    'Logistiek & Supply Chain': [
      'Logistics & Supply Chain Management',
      'Supply Chain Management',
      'Logistiek',
      'Logistiek Management'
    ],
    'Human Resources & Organisatie': [
      'Human Resource Management',
      'Officemanagement',
      'Facilitair Eventmanagement',
      'Facility Management'
    ],
    'Sales & Retail': [
      'Sales en Accountmanagement',
      'Ondernemerschap & Retail Management'
    ],
    'Food & Fashion Business': [
      'Food, Business & Innovation',
      'Fashion Business Professional'
    ]
  },
  'Onderwijs & Pedagogiek': {
    'Educatie & Didactiek': [
      'Educatief Professional Beroepsonderwijs',
      'Pedagogisch Educatief Professional',
      'Didactisch Educatief Professional'
    ],
    'Onderwijs & Ondersteuning': [
      'Onderwijsondersteuner Gezondheidszorg en Welzijn',
      'Onderwijsondersteuner Consumptieve Techniek I en II',
      'Onderwijsondersteuner Omgangskunde',
      'Onderwijsondersteuner Technisch Beroepsonderwijs',
      'Schrijftolk',
      'Kinderopvang'
    ]
  },
  'Design & Kunst': {
    'Design & Interieur': [
      'Design',
      'Interior Brand Identity',
      'Interieurvormgever'
    ],
    'Creatieve Kunsten': [
      'Arts & Crafts'
    ]
  },
  'Gezondheid & Zorg': {
    'Zorg & Welzijn': [
      'Management in de Zorg',
      'Zorg en Technologie',
      'Praktijkondersteuner Huisarts',
      'Ervaringsdeskundigheid in Zorg en Welzijn'
    ],
    'Zorg & Veiligheid': [
      'Zorg & Veiligheid'
    ]
  },
  'Exact & Informatica': {
    'Software & Development': [
      'Software Development',
      'Frontend Design & Development'
    ],
    'Cybersecurity & IT Management': [
      'Cybersecurity',
      'Cyber Safety & Security',
      'Information Security',
      'IT Service Management',
      'ICT Service Management'
    ],
    'ICT & Data': [
      'ICT & Telecommunicatie',
      'ICT-Engineer',
      'AD-ICT',
      'Informatica',
      'ICT Internet of Things',
      'Data Analytics',
      'ICT'
    ]
  },
  'Techniek & Bouw': {
    'Engineering & Mechatronica': [
      'Engineering',
      'Werktuigbouwkunde',
      'Mechatronica',
      'Mechatronica in de Smart Industry',
      'Embedded Systems Engineering'
    ],
    'Bouw & Constructie': [
      'Bouwkunde',
      'Bouwtechnisch Medewerker',
      'Integraal Bouwmanagement',
      'Civiele Techniek Projectvoorbereiding en Realisatie',
      'Built Environment',
      'Bouwmanagement'
    ],
    'Installatie & Onderhoud': [
      'Gebouwgebonden Installatietechniek',
      'Maintenance',
      'Smart Asset Maintenance'
    ],
    'Energietransitie & Duurzaamheid': [
      'Energietransitie Engineer'
    ],
    'Automatisering & Robotica': [
      'Industriële Automatisering en Robotica',
      'Industriële Automatisering'
    ],
    'Transport & Maritiem': [
      'Maritieme Techniek',
      'Automotive'
    ]
  },
  'Gedrag & Maatschappij': {
    'Sociaal Werk & Participatie': [
      'Sociaal Werk',
      'Participatie en Buurtontwikkeling',
      'Ervaringsdeskundigheid in Zorg en Welzijn'
    ],
    'Jeugd & Sport': [
      'Sport',
      'Jeugdwerker'
    ]
  },
  'Recht & Bestuur': [
    'Juridisch Medewerker',
    'Rechten'
  ],
  'Aarde & Milieu': {
    'Voedsel & Landbouw': [
      'Tuinbouwmanagement',
      'Dier- en Veehouderij',
      'Tuinbouw en Akkerbouw',
      'Melkveehouderij',
      'Voedingsmiddelentechnologie'
    ],
    'Natuur & Landschap': [
      'Tuin- en Landschapsinrichting',
      'Land- en Watermanagement',
      'Groene Leefomgeving',
      'Omgevingskunde'
    ],
    'Milieu & Educatie': [
      'Educatie en Kennismanagement Groene Sector'
    ],
    'Creatieve Groenvoorziening': [
      'Bloemsierkunst'
    ],
    'Culinary & Voeding': [
      'Culinary Professional'
    ]
  }
};

// HBO Master studies met categorieën en subcategorieën
export const HBO_MASTER_STUDIES = {
  'Economie & Bedrijfskunde': {
    'Algemeen Management & Strategie': [
      'Master of Business Management',
      'Master of Strategic Management',
      'Executive MBA',
      'Strategy & Leadership',
      'MBA Leadership in Sustainability',
      'MBA Innovation & Leadership',
      'Master Circulaire Economie',
      'Business Engineering',
      'Interdisciplinary Business Professional',
      'Integraal Adviseur MKB',
      'Intergrale Bedrijfsvoering'
    ],
    'Ondernemerschap & Innovatie': [
      'Master in Consultancy and Entrepreneurship',
      'Management and Innovation',
      'Digital Driven Business',
      'Economische Transformatie',
      'Design Driven Innovation',
      'Imagineering, Master in Business Innovation from the Experience Perspective',
      'Applied Sustainability Management',
      'Sustainable Business Transition',
      'Action Learning MBA',
      'Business Sales'
    ],
    'Financieel Management & Control': [
      'Master in Controlling',
      'Master of Financial Management and Control',
      'Finance and Control'
    ],
    'Human Resource Management & Organisatie': [
      'Organisatie Coaching',
      'Human Resource Management (Master)',
      'Kwaliteitsmanagement',
      'Risico Management'
    ],
    'Project- & Eventmanagement': [
      'Project, Programma & Portfolio Management',
      'Projectmanagement',
      'Strategic Events Management'
    ],
    'Supply Chain & Facility Management': [
      'International Supply Chain Management',
      'Master in International Supply Chain Management',
      'Facility and Real Estate Management'
    ],
    'Toerisme, Hospitality & Leisure': [
      'International Hospitality and Service Management',
      'Leading Hotel Transformation',
      'Master of International Hospitality Management',
      'International Leisure, Tourism & Events Management',
      'Tourism Destination Management'
    ]
  },
  'Onderwijs & Opvoeding': {
    'Lerarenopleidingen': [
      'Leraar Geschiedenis',
      'Leraar Nederlands',
      'Leraar Fries',
      'Leraar Biologie',
      'Leraar Algemene Economie',
      'Leraar Wiskunde',
      'Leraar Frans',
      'Leraar Godsdienst',
      'Leraar Engels',
      'Leraar Duits',
      'Leraar Bedrijfseconomie',
      'Leraar Natuurkunde',
      'Leraar Aardrijkskunde',
      'Leraar Scheikunde',
      'Leraar Maatschappijleer'
    ],
    'Onderwijsinnovatie & -technologie': [
      'Leren Innoveren',
      'Onderwijs & Technologie',
      'Innovation & Leadership in Education',
      'Ontwerpen van Eigentijds Leren',
      'Toetsdeskundige',
      'Talentontwikkeling en Diversiteit',
      'Master Leiderschap in Onderwijs',
      'Leren en Innoveren',
      'Docent Hoger Gezondheidszorg Onderwijs'
    ],
    'Onderwijsmanagement & -beleid': [
      'Educational Leadership',
      'Master Educational Leadership',
      'Master Leiderschap en Innovatie Kind en Educatie',
      'Professioneel Meesterschap',
      'Passend Meesterschap'
    ],
    'Pedagogiek & Speciaal Onderwijs': [
      'Educational Needs',
      'Pedagogiek',
      'Taalbewust Leren'
    ]
  },
  'Kunst & Cultuur': {
    'Beeldende Kunst & Vormgeving': [
      'Master of Arts in Fine and Design',
      'Master Design',
      'Animatie',
      'Master Scientific Illustration',
      'Interieurarchitectuur',
      'Interior Architecture',
      'Type and Media'
    ],
    'Podiumkunsten & Muziek': [
      'Choreografie',
      'Performing Public Space',
      'Operationeel Leiderschap in Performing Arts',
      'Theater',
      'Performance Practices',
      'Opera',
      'Sonologie'
    ],
    'Media & Creatieve Industrie': [
      'Film',
      'DAS Creative Producing',
      'Crossover Creativity',
      'Applied Museum and Heritage Studies'
    ],
    'Filosofie & Theologie': [
      'Evangelical Theology',
      'Toegepaste Islamitische Theologie',
      'Toegepaste Filosofie'
    ]
  },
  'Gezondheid & Zorg': {
    'Fysiotherapie & Bewegingszorg': [
      'Fysiotherapie en Innovatie in Beweegzorg',
      'Orofaciale Fysiotherapie',
      'Sportfysiotherapie',
      'Fysiotherapie en Wijkgerichte Beweegzorg',
      'Master Kinderfysiotherapie',
      'Fysiotherapie in de Geriatrie',
      'Manuele Therapie',
      'Musculoskeletale Revalidatie',
      'Musculoskeletale Echografie voor Fysiotherapeuten',
      'Bekkenfysiotherapie'
    ],
    'Verpleegkunde & Gezondheidszorg': [
      'Advanced Nursing Practice',
      'Verpleegkunde Specialist/ANP GGZ',
      'GGZ-Verpleegkunde (GGZ-V)',
      'Critical Care',
      'Public Health and Health Equity',
      'Physician Assistant'
    ],
    'Innovatie & Leiderschap in Zorg': [
      'Health Innovation',
      'Gezondheidsinnovatie',
      'Innovatie in Zorg en Welzijn',
      'Advanced Health Informatics Practice',
      'Leiderschap voor Persoonsgerichte Zorg en Ondersteuning',
      'Healthy Ageing Professional'
    ],
    'Medische & Life Sciences': [
      'Medical Imaging/Radiation Oncology',
      'Molecular Life Sciences',
      'Neurorevalidatie'
    ]
  },
  'Techniek & ICT': {
    'ICT & Data Science': [
      'Management van IT',
      'Informatics',
      'Applied IT',
      'ICT: Software Engineering',
      'Applied Artificial Intelligence',
      'Business Information',
      'Cyber Security Engineering',
      'Responsible AI Innovation',
      'Computer Vision & Data Science',
      'Digital Design',
      'Applied Data Science',
      'Human-Centered Artificial Intelligence',
      'Digital Forensics',
      'Master of ICT and Business Innovation'
    ],
    'Engineering & Technologie': [
      'Polymer Engineering',
      'Master Digitale Technologie',
      'Robotics Systems Engineering',
      'System Design',
      'Next Level Engineering',
      'Applied Nanotechnology',
      'Innovatie Textile Development'
    ],
    'Bouw & Infra': [
      'Architectuur',
      'Stedenbouw',
      'Urban Technology',
      'Constructief Ontwerpen',
      'Master in Structural Engineering',
      'Master of Pipeline Technology'
    ],
    'Maritiem & Transport': [
      'Opleiding tot Registerloods: Master in Maritieme Piloting',
      'Shipping and Transport',
      'Maritime Innovations'
    ],
    'Games & Digitale Innovatie': [
      'Game Technology',
      'Serious Gaming',
      'Data-driven Design'
    ]
  },
  'Gedrag & Maatschappij': {
    'Psychologie & Coaching': [
      'Begeleidingskunde',
      'Toegepaste Psychologie voor Professionals',
      'Contextuele Benadering',
      'Speltherapie',
      'Ervaringsdeskundigheid'
    ],
    'Sociale Wetenschappen & Zorg': [
      'Social Work',
      'Master Systemisch Werken met Jeugd',
      'Vaktherapie',
      'Master Sport en Bewegingsonderwijs',
      'Jeugdzorg',
      'Human Development',
      'Community Development',
      'Health Care and Social Work'
    ],
    'Sport & Beweging': [
      'Sport Business & Leadership',
      'Sport en Beweeginnovatie',
      'Performance, Sport and Health',
      'Lichamelijke Opvoeding en Sportpedagogiek'
    ]
  },
  'Recht & Bestuur': {
    'Bestuur & Veiligheid': [
      'Master Urban Management',
      'Bestuurskunde',
      'Veiligheid en Digitalisering',
      'Master of Crisis and Public Order Management'
    ],
    'Recht & Juridische Dienstverlening': [
      'Bedrijfsrecht',
      'Toegepaste Recht',
      'Sociaal Juridische Expert',
      'Master Legal Management'
    ]
  },
  'Taal & Communicatie': {
    'Communicatie & Media': [
      'Professional Master in Media Innovation',
      'International Communication Management',
      'International Communication',
      'Strategische Communicatie',
      'Content & Media Strategy'
    ]
  },
  'Recht & Bestuur': {
    'Algemeen Recht & Rechtsgeleerdheid': [
      'Nederlands recht',
      'Rechtsgeleerdheid',
      'Privaatrecht',
      'Publiekrecht',
      'Rechtwetenschappelijk Onderzoek'
    ],
    'Internationaal & Europees Recht': [
      'International Laws',
      'International and European Law',
      'International Business Law',
      'International Commercial Law',
      'Globalisation and Law',
      'European Private Law',
      'European Law in a Global Context',
      'Public International Law',
      'International Tax Law',
      'International and European Tax Law',
      'Advanced Studies in International Civil and Commercial Law',
      'Advanced Studies in Public International Law',
      'Advanced Studies in European and International Business Law',
      'Advanced Studies in European and International Human Rights Law'
    ],
    'Ondernemingsrecht & Financieel Recht': [
      'Ondernemingsrecht',
      'Onderneming en recht',
      'Commercial Law',
      'Advanced Studies in Law and Finance',
      'Law and Economics'
    ],
    'Arbeidsrecht & Sociaal Recht': [
      'Arbeidsrecht',
      'Recht en Arbeid',
      'Sociaal Recht en Sociale Politiek'
    ],
    'Fiscaal & Notarieel Recht': [
      'Fiscaal Recht',
      'Notarieel Recht'
    ],
    'Technologie, Privacy & Intellectueel Eigendom': [
      'Law and Technology',
      'IT-recht',
      'Advanced Master Intellectual Property Law and Knowledge Management LL.M.',
      'Advanced Studies in Law and Digital Technologies',
      'Gegevensbescherming en Privacyrecht'
    ],
    'Klimaat-, Energie- & Ruimterecht': [
      'Energy and Climate Law',
      'Advanced Master in Energy Law',
      'Advanced Studies in Air and Space Law'
    ],
    'Strafrecht, Criminologie & Veiligheid': [
      'Criminologie',
      'Forensische Criminologie',
      'Global Criminal Law',
      'International Criminal Law',
      'International Crimes, Conflict and Criminology',
      'Criminaliteit en Rechtshandhaving',
      'Forensica, Criminologie en Rechtspleging',
      'Law and Politics of International Security'
    ],
    'Bestuurskunde & Openbaar Bestuur': [
      'Bestuurskunde',
      'Public Administration',
      'Recht en Bestuur',
      'Publiek Management',
      'Management Publieke Sector',
      'Executive Master of Public and Non-profit Management',
      'Research in Public Administration and Organizational Science'
    ],
    'Beleid & Organisatie': [
      'Public Policy and Human Development',
      'Erasmus Mundus Master\'s Program in Public Policy',
      'International Public Management and Public Policy',
      'Conflict Resolution and Governance',
      'Beleid, Communicatie en Organisatie',
      'Sustainability Science, Policy and Society',
      'Governance of Sustainability',
      'Organization and Management Studies'
    ],
    'Internationale Betrekkingen & Diplomatie': [
      'Internationale betrekkingen',
      'International Relations and Diplomacy'
    ],
    'Specialisaties in Recht': [
      'Advanced Studies in International Children\'s Rights',
      'Advanced Studies in International Dispute Settlement and Arbitration',
      'Advanced LLM in Technology Governance',
      'Mater of Science in Policing',
      'Togamaster',
      'Jeugdrecht',
      'Aansprakelijkheid en verzekering'
    ],
    'Management & Leiderschap binnen Recht en Bestuur': [
      'Executive Master of Management and Organization',
      'Executive Master of Management in Education'
    ]
  }
};

// Universiteit Bachelor studies met categorieën en subcategorieën
export const UNIVERSITEIT_BACHELOR_STUDIES = {
  'Economie & Bedrijfskunde': {
    'Economie': [
      'Economie',
      'Economie & Bedrijfseconomie',
      'Economie en Beleid',
      'Economie & Samenleving'
    ],
    'Bedrijfskunde & Management': [
      'Bedrijfskunde',
      'Business Administration',
      'Technische Bedrijfskunde',
      'International Business Administration',
      'International Business',
      'Entrepreneurship and Business Innovation',
      'Business Engineering'
    ],
    'Fiscale & Financiële Wetenschappen': [
      'Fiscale Economie',
      'Fiscaal Recht',
      'Accountancy',
      'Actuariële Wetenschappen'
    ],
    'Data & Analytics': [
      'Econometrics and Data Science',
      'Econometrie en Operationele Research',
      'Business Analytics'
    ]
  },
  'Onderwijs & Opvoeding': {
    'Onderwijswetenschappen & Pedagogiek': [
      'Pedagogische Wetenschappen',
      'Pedagogische Wetenschappen van Primair Onderwijs',
      'Onderwijswetenschappen',
      'Onderwijs en Opvoeding'
    ],
    'Lerarenopleidingen': [
      'Lerarenopleiding Open Universiteit'
    ]
  },
  'Kunst, Cultuur & Geschiedenis': {
    'Filosofie & Theologie': [
      'Filosofie',
      'Theologie',
      'Theologie en Religiewetenschappen',
      'Filosofie van een Bepaald Wetenschapsgebied',
      'Religiewetenschappen'
    ],
    'Kunst & Media': [
      'Kunstgeschiedenis',
      'Media en Cultuur',
      'Kunsten, Cultuur en Media',
      'Media, Kunst, Design en Architectuur',
      'Theaterwetenschap',
      'Film en Literatuurwetenschap'
    ],
    'Geschiedenis & Cultuurwetenschappen': [
      'Geschiedenis',
      'Algemene Cultuurwetenschappen',
      'Cultuurwetenschappen',
      'Oudheidwetenschappen',
      'Archeologie'
    ]
  },
  'Gezondheid & Levenswetenschappen': {
    'Geneeskunde & Zorg': [
      'Geneeskunde',
      'Tandheelkunde',
      'Diergeneeskunde',
      'Zorg, Gezondheid & Samenleving'
    ],
    'Biomedische & Farmaceutische Wetenschappen': [
      'Biomedical Sciences',
      'Biomedische Wetenschappen',
      'Brain Science',
      'Farmaceutische Wetenschappen',
      'Bio-Farmaceutische Wetenschappen',
      'Farmacie'
    ],
    'Gezondheidswetenschappen & Preventie': [
      'European Public Health',
      'Gezondheidswetenschappen',
      'Gezondheid en Leven',
      'Gezondheid en Maatschappij'
    ],
    'Bewegingswetenschappen & Revalidatie': [
      'Bewegingswetenschappen',
      'Physiotherapy and Rehabilitation Sciences'
    ],
    'Voeding & Levenswetenschappen': [
      'Voeding en Gezondheid',
      'Animal Sciences',
      'Molecular Life Sciences',
      'Molecular and Biophysical Life Sciences',
      'Regenerative Medicine and Technology',
      'Klinische Technologie',
      'Moleculaire Levenswetenschappen'
    ]
  },
  'Exacte Wetenschappen & Informatica': {
    'Wiskunde & Natuurkunde': [
      'Wiskunde',
      'Technische Wiskunde',
      'Mathematics',
      'Natuurkunde',
      'Technische Natuurkunde',
      'Natuur- en Sterrenkunde',
      'Sterrenkunde'
    ],
    'Chemie & Life Sciences': [
      'Scheikunde',
      'Chemistry',
      'Scheikundige Technologie',
      'Molecular Science and Technology'
    ],
    'Informatica & Kunstmatige Intelligentie': [
      'Informatica',
      'Computer Science',
      'Technical Computer Science',
      'Business Information Technology',
      'Technische Informatica',
      'Medische Informatiekunde',
      'Business Analytics',
      'Kunstmatige Intelligentie',
      'Artificial Intelligence',
      'Cognitive Science and Artificial Intelligence',
      'Data Science and Artificial Intelligence',
      'Data Science and Society'
    ]
  },
  'Techniek & Engineering': {
    'Werktuigbouwkunde & Elektrotechniek': [
      'Werktuigbouwkunde',
      'Mechanical Engineering',
      'Mechatronica',
      'Electrical Engineering'
    ],
    'Bouwkunde & Civiele Techniek': [
      'Bouwkunde',
      'Civiele Techniek',
      'Civil Engineering',
      'Technische Bestuurskunde'
    ],
    'Lucht- & Ruimtevaart': [
      'Luchtvaart- en Ruimtevaarttechniek',
      'Maritieme Techniek'
    ],
    'Biotechnologie & Industriële Technologie': [
      'Biomedische Technologie',
      'Industrial Design',
      'Industrieel Ontwerpen',
      'Industrial Design Engineering',
      'Circular Engineering',
      'Biotechnologie',
      'Food Technology'
    ]
  },
  'Gedrag & Maatschappij': {
    'Psychologie & Cognitieve Wetenschappen': [
      'Psychologie',
      'Psychobiologie',
      'Cognition, Language and Communication',
      'Psychology & Technology',
      'Computational Social Science'
    ],
    'Sociologie & Antropologie': [
      'Sociologie',
      'Culturele Antropologie en Ontwikkelingssociologie',
      'Internationale Ontwikkelingsstudies',
      'Vrijetijdwetenschappen'
    ],
    'Organisatie & Personeel': [
      'Personeelwetenschappen',
      'Organisatie- en Managementwetenschappen'
    ]
  },
  'Recht, Bestuur & Politiek': {
    'Recht': [
      'Rechtsgeleerdheid',
      'Notarieel Recht',
      'European Law School',
      'Global Law',
      'International and European Law',
      'Fiscaal Recht'
    ],
    'Politicologie & Bestuurskunde': [
      'Politicologie',
      'Internationale Betrekkingen en Internationale Organisatie',
      'Bestuurskunde',
      'Bestuurs- en Organisatiewetenschap',
      'Law in Society'
    ],
    'Criminologie & Veiligheid': [
      'Criminologie',
      'Security Studies'
    ]
  },
  'Taal & Communicatie': {
    'Communicatie & Media': [
      'Communicatiewetenschap',
      'Communicatie- en Informatiewetenschappen',
      'International Bachelor\'s Programme in Communication and Media',
      'Media en Informatie'
    ],
    'Taalwetenschap & Literatuur': [
      'Taalwetenschap',
      'Literatuurwetenschap',
      'Literatuur en Samenleving'
    ],
    'Specifieke Talen & Culturen': [
      'English Language and Culture',
      'Franse Taal en Cultuur',
      'Duitse Taal en Cultuur',
      'Spaanse Taal en Cultuur',
      'Italiaanse Taal en Cultuur',
      'Japanstudies',
      'Koreastudies',
      'Scandinavische Talen en Culturen',
      'Nederlandse Taal en Cultuur',
      'Midden-Oostenstudies',
      'Arabische Taal en Cultuur',
      'Griekse en Latijnse Taal en Cultuur',
      'Romaanse Talen en Culturen',
      'Chinastudies',
      'Russische Studies'
    ]
  },
  'Aarde & Milieu': {
    'Aardwetenschappen & Duurzaamheid': [
      'Technische Aardwetenschappen',
      'Aarde, Economie en Duurzaamheid',
      'Future Planet Studies',
      'Soil, Water, Atmosphere',
      'Milieu-natuurwetenschappen',
      'Environmental Sciences'
    ],
    'Geografie, Planologie & Beheer': [
      'Geografie, Planologie en Milieu',
      'Human Geography and Planning',
      'Spatial Planning and Design',
      'International Land and Water Management',
      'Bos- en Natuurbeheer'
    ],
    'Biologie & Plantenwetenschappen': [
      'Biologie',
      'Plantenwetenschappen',
      'Marine Sciences'
    ]
  },
  'Interdisciplinaire & Speciale Studies': {
    'Liberal Arts & Multidisciplinaire Studies': [
      'Liberal Arts and Sciences',
      'Beta-gamma',
      'Global Studies',
      'Urban Studies',
      'Science for Sustainable Societies'
    ],
    'Geïntegreerde Maatschappelijke Studies': [
      'Philosophy, Politics and Economics',
      'Global Responsibility and Leadership',
      'Technology and Liberal Arts & Sciences'
    ],
    'Technologische Innovatie & Creativiteit': [
      'Creative Technology',
      'Advanced Technology'
    ]
  },
  'Krijgswetenschappen & Defensie': {
    'Militaire Wetenschappen & Technologie': [
      'Militaire Systemen & Technologie',
      'Militaire Bedrijfswetenschappen'
    ],
    'Veiligheid & Internationale Studies': [
      'Cybersecurity & Cybercrime',
      'International Studies',
      'Politics, Psychology, Law and Economics'
    ]
  }
};

// Universiteit Master studies met categorieën en subcategorieën
export const UNIVERSITEIT_MASTER_STUDIES = {
  'Management & Bedrijfskunde': {
    'Algemeen Management & Bedrijfskunde': [
      'Business Administration',
      'International MSc in Business Administration',
      'Executive MBA',
      'Executive MBA: Leading with Purpose',
      'International Full Time Master of Business Administration',
      'Global Executive MBA',
      'Master of Arts in Management',
      'Executive Master in Business Administration',
      'Management',
      'Bedrijfskunde',
      'International Management'
    ],
    'Financieel Management & Accounting': [
      'Finance',
      'International Finance',
      'Financial Economics',
      'Finance & Investments',
      'International Financial Management',
      'Actuarial Science and Mathematical Finance',
      'Quantitative Finance and Actuarial Science',
      'Actuarial Sciences and Mathematical Finance',
      'Accounting, Auditing and Control',
      'Accountancy',
      'Executive Master of Finance and Control',
      'Executive Master in Finance',
      'Executive Master of Business Valuation',
      'Law & Finance',
      'Economics and Business',
      'Executive Master of Science in Insurance & Risk',
      'Controlling',
      'Executive Master in Finance and Control',
      'Executive Master of Actuarial Science',
      'International Executive Master of Finance and Control'
    ],
    'Marketing & Strategie': [
      'Marketing',
      'Marketing Management',
      'Marketing Analytics',
      'Corporate Communication',
      'Strategic Management',
      'Strategic Entrepreneurship',
      'Executive Master of Marketing and Customer Management'
    ],
    'Supply Chain, Operations & Logistiek': [
      'Supply Chain Management',
      'Global Supply Chain Management and Change',
      'Transport and Supply Chain Management',
      'Customs and Supply Chain Compliance',
      'Operations Management and Logistics',
      'Maritime Economics and Logistics',
      'Transport, Infrastructure and Logistics',
      'Spatial, Transport and Environmental Economics'
    ],
    'Innovatie & Digital Business': [
      'Digital Business and Innovation',
      'Digital Business and Economics',
      'Management of Innovation',
      'Innovation Management',
      'Business Information Management',
      'Business Intelligence and Smart Services',
      'Executive Master Information Management and Digital Transformations',
      'Information Management'
    ],
    'Ondernemerschap & Verandermanagement': [
      'Management, Policy Analysis and Entrepreneurship in the Health and Life Sciences',
      'Entrepreneurship',
      'Sustainable Entrepreneurship',
      'Verandermanagement',
      'People, Organisations & Change'
    ],
    'Economie & Publieke Sector': [
      'Economics',
      'International Economics and Business',
      'Economics of Public Policy and Management',
      'Economics of Competition and Regulation',
      'Economics and Business',
      'Economie van de Publieke Sector',
      'International Economics and Sustainable Development'
    ],
    'Econometrie, Wiskunde & Data Science': [
      'Econometrics and Operations Research',
      'Econometrics, Operations Research and Actuarial Studies',
      'Econometrics and Mathematical Economics',
      'Econometrics and Management Science',
      'Data Science and Business Analytics',
      'Research Master Business Data Science'
    ],
    'Vastgoed & Risicomanagement': [
      'Master of Real Estate',
      'Real Estate Studies',
      'Master of Science in Real Estate',
      'Executive Master of Accountancy',
      'Risicomanagement'
    ],
    'HR & Organisatie': [
      'Human Resource Management',
      'Human Resource Studies'
    ],
    'Executive & Research Masters': [
      'Research Master in Economics and Business (research)',
      'Research Master in Economics (Research)',
      'Tinbergen Institute Research Master in Economics',
      'Economic and Financial Research (research)',
      'Multidisciplinary Economics (research)'
    ]
  },
  'Onderwijs & Opvoeding': {
    'Algemene Onderwijswetenschappen & Pedagogiek': [
      'Onderwijswetenschappen',
      'Pedagogische Wetenschappen',
      'Pedagogische en Onderwijswetenschappen',
      'Education and Child Studies',
      'Educational Sciences: Learning in Interaction (research)',
      'Child Development and Education (research master)',
      'Educational Science and Technology'
    ],
    'Primair Onderwijs': [
      'Educatieve Master Primair Onderwijs',
      'Curriculumontwikkeling voor Primair Onderwijs'
    ],
    'Voortgezet Onderwijs (Docentenopleidingen)': [
      'Educatie in de Taal en Cultuurwetenschappen',
      'Educatie in de Mens en Maatschappijwetenschappen',
      'Educatie in de Bètawetenschappen',
      'Educatie en Communicatie in de Bètawetenschappen',
      'Leraar Voorbereidend Hoger Onderwijs in de Bètawetenschappen',
      'Leraar Voorbereidend Hoger Onderwijs in de Mens en Maatschappijwetenschappen',
      'Leraar Voorbereidend Hoger Onderwijs in de Taal en Cultuurwetenschappen',
      'Leraar Godsdienst en Levensbeschouwing (eerste graad)'
    ],
    'Specialistische Onderwijsprogramma\'s & Innovatie': [
      'Learning and Development in Organisations',
      'Gifted Education and Care',
      'Science Education and Communication',
      'Executieve MSc Senior Docent Ontwerpen'
    ]
  },
  'Kunst & Cultuur': {
    'Geschiedenis & Archeologie': [
      'Geschiedenis',
      'Archeologie',
      'Historical, Literary and Cultural Studies',
      'History and Philosophy of Science'
    ],
    'Filosofie & Logica': [
      'Filosofie',
      'Logic',
      'Philosophy of Science, Technology and Society',
      'Filosofie van Cultuur en Bestuur'
    ],
    'Kunst, Cultuur & Erfgoed': [
      'Kunst & Cultuurwetenschappen',
      'Mediastudies',
      'Arts, Literature and Media',
      'Erfgoedstudies',
      'Conservering en Restauratie van Cultureel Erfgoed',
      'Executive Master in Cultural Leadership'
    ],
    'Theologie & Religie': [
      'Theologie',
      'Theologie & Religiewetenschappen',
      'Religious Studies',
      'Herbronning Gereformeerde Theologie',
      'Geestelijke Verzorging',
      'Humanistiek'
    ],
    'Zorgethiek & Beleid': [
      'Zorgethiek en Beleid'
    ],
    'Algemene Geesteswetenschappen': [
      'Humanities'
    ]
  },
  'Gezondheid': {
    'Geneeskunde & Klinisch Onderzoek': [
      'Geneeskunde',
      'Geneeskunde en Klinisch Onderzoek',
      'Geneeskunde, Klinisch Onderzoeker',
      'Medicine',
      'Technical Medicine',
      'Oncology',
      'Oral Health Sciences',
      'Tandheelkunde',
      'Diergeneeskunde'
    ],
    'Biomedische Wetenschappen & Farmacie': [
      'Biomedical Sciences',
      'Biomedical Technology and Physics',
      'Bio-Pharmaceutical Sciences',
      'Medical Pharmaceutical Sciences',
      'Molecular Medicine',
      'Molecular Medicine and Innovative Treatment',
      'Molecular Sciences',
      'Molecular Life Sciences',
      'Drug Discovery Sciences',
      'Infection and Immunity',
      'Transfusion Medicine and Cellular and Tissue Therapies'
    ],
    'Gezondheidswetenschappen & Volksgezondheid': [
      'Health Sciences',
      'Master in Health Sciences',
      'Global Health',
      'European Master in Health Economics and Management',
      'Governance and Leadership in European Public Health',
      'Population Health Management',
      'Clinical and Psychosocial Epidemiology',
      'Epidemiology',
      'Public Health (onderliggend aan meerdere opleidingen)'
    ],
    'Gezondheidseconomie, Beleid & Management': [
      'Health Economics, Policy and Law',
      'Healthcare Policy, Innovation and Management',
      'Zorgmanagement',
      'Executive Master of Health Administration',
      'Health and Digital Transformation'
    ],
    'Voeding, Innovatie & Veiligheid': [
      'Nutrition and Health',
      'Health Food Innovation Management',
      'Food Safety',
      'Food Quality Management'
    ],
    'Bewegingswetenschappen & Sport': [
      'Human Movement Sciences',
      'Bewegingswetenschappen',
      'Human Movement Sciences: Sport, Exercise and Health',
      'Sport Sciences',
      'Musculoskeletal Physiotherapy Sciences'
    ],
    'Medische Informatica & Technologie': [
      'Medical Informatics',
      'Health Informatics'
    ],
    'Arbeidsgezondheid & Duurzaamheid': [
      'Occupational Health and Sustainable Work',
      'European MSc in Occupational Therapy'
    ],
    'Onderwijs & Ethiek binnen de Gezondheidszorg': [
      'Health Professions Education',
      'Evidence-Based Practice in Health Care',
      'Medical Humanities'
    ],
    'Kwaliteit, Veiligheid & Innovatie in de Zorg': [
      'Kwaliteit en Veiligheid in de Patiëntenzorg',
      'Health Education and Promotion'
    ],
    'Dierwetenschappen & Aquatische Wetenschappen': [
      'Animal Sciences',
      'Aquaculture and Marine Resource Management'
    ]
  },
  'Exact & Informatie': {
    'Informatica & Softwareontwikkeling': [
      'Computer Science',
      'Computer Science and Engineering',
      'Software Engineering',
      'Business Information Technology',
      'ICT in Business and the Public Sector',
      'Business Process Management and IT',
      'Executive Master of IT-Auditing'
    ],
    'Kunstmatige Intelligentie & Data Science': [
      'Artificial Intelligence',
      'Data Science and Artificial Intelligence Technology',
      'Applied Data Science',
      'Data Science and Society',
      'Data Science for Decision Making',
      'Business Analytics',
      'Computational Science',
      'Computational Cognitive Science',
      'Stochastics and Financial Mathematics'
    ],
    'Cybersecurity & Netwerken': [
      'Security and Network Engineering',
      'Computer Security',
      'Forensic Science'
    ],
    'Robotica & Mens-Technologie Interactie': [
      'Robotics',
      'Human-Technology Interaction',
      'Interaction Technology',
      'Creative Intelligence & Technology'
    ],
    'Wiskunde & Statistiek': [
      'Mathematics',
      'Applied Mathematics',
      'Mathematische Wetenschappen',
      'Statics and Data Science'
    ],
    'Natuurkunde & Sterrenkunde': [
      'Physics',
      'Applied Physics',
      'Physics and Astronomy',
      'Astronomy',
      'Quantum Information Science & Technology',
      'Quantum Computer Science',
      'Science and Technology of Nuclear Fusion'
    ],
    'Chemie & Materiaalkunde': [
      'Chemistry',
      'Chemical Science & Engineering',
      'Chemical Engineering',
      'Chemische Wetenschappen'
    ],
    'Innovatie & Wetenschapsmanagement': [
      'Innovation Sciences',
      'Science and Innovation',
      'Science, Business and Innovation',
      'Natuurwetenschappen en Bedrijf',
      'Technology and Operations Management'
    ]
  },
  'Techniek': {
    'Biotechnologie & Levenswetenschappen': [
      'Biotechnology',
      'Life Science and Technology',
      'Biomolecular Sciences',
      'Bioinformatics',
      'Biomedical Engineering',
      'Biosystems Engineering',
      'Medical Engineering'
    ],
    'Duurzaamheid & Energie': [
      'Sustainable Energy Technology',
      'European Master in Renewable Energy',
      'Environmental and Energy Management',
      'Environmental Engineering',
      'Water Technology'
    ],
    'Elektrotechniek & Embedded Systems': [
      'Electrical Engineering',
      'Embedded Systems'
    ],
    'Werktuigbouwkunde & Mechatronica': [
      'Mechanical Engineering',
      'Automotive Technology',
      'Systems and Control'
    ],
    'Bouwkunde, Stedenbouw & Civiele Techniek': [
      'Civil Engineering',
      'Civil Engineering and Management',
      'Architecture, Urbanism and Building Sciences',
      'Architecture, Building and Planning',
      'Construction Management and Engineering',
      'Urban Management and Development (M.Sc.)',
      'Master City Developer',
      'The Berlage post-master in Architecture and Urban Design'
    ],
    'Maritieme & Offshore Techniek': [
      'Marine Technology',
      'Offshore and Dredging Engineering'
    ],
    'Ruimtevaart & Nanotechnologie': [
      'Aerospace Engineering',
      'Nanotechnology',
      'Nanoscience'
    ],
    'Industrieel Ontwerpen & Productontwikkeling': [
      'Industrial Design Engineering',
      'Industrial Design',
      'Integrated Product Design',
      'Design for Interaction',
      'Strategic Product Design'
    ],
    'Technologiemanagement & Beleidsanalyse': [
      'Complex Systems Engineering and Management',
      'Engineering and Policy Analysis',
      'Management of Technology'
    ],
    'Materialen & Productietechnologie': [
      'Materials Science and Engineering'
    ],
    'Data Science & Ondernemerschap': [
      'Data Science in Business and Entrepreneurship'
    ],
    'Humanitaire & Sociale Techniek': [
      'Humanitarian Engineering'
    ]
  },
  'Gedrag & Maatschappij': {
    'Psychologie & Neurowetenschappen': [
      'Psychologie',
      'Psychologie en Geestelijke Gezondheid',
      'Gezondheidszorgpsychologie',
      'Medische Psychologie',
      'Cognitive Neuropsychology',
      'Social & Health Psychology',
      'Social Psychology',
      'Social Psychology: Regulation of Social Behaviour',
      'Forensic Psychology',
      'Individual Differences and Assessment',
      'Cognitive and Clinical Neuroscience',
      'Neuroscience',
      'Neuroscience and Cognition',
      'Behavioural and Cognitive Neurosciences',
      'Genes in Behaviour and Health',
      'Human Decision Science'
    ],
    'Sociologie & Sociale Wetenschappen': [
      'Sociologie',
      'Sociology and Social Research',
      'Social and Behavioural Sciences',
      'Behavioural and Social Sciences',
      'Behavioural Science',
      'Interdisciplinaire Sociale Wetenschap',
      'Social and Cultural Science: Comparative Research on Societies',
      'Societal Transitions',
      'Social Sciences',
      'Social Sciences for a Digital Society',
      'Culture, Organization and Management',
      'Burgerschap en Kwaliteit van Samenleven'
    ],
    'Antropologie & Culturele Studies': [
      'Cultural Anthropology: Sociocultural Transformation',
      'Culturele Antropologie',
      'Culturele Antropologie en Sociologie der Niet-Westerse Samenlevingen',
      'Social and Cultural Anthropology',
      'Cultural Anthropology and Development Sociology',
      'Medische Antropologie en Sociologie'
    ],
    'Internationale Ontwikkeling & Globalisering': [
      'International Development Studies',
      'International Development',
      'Development Studies',
      'Globalisation and Development Studies',
      'Development and Rural Innovation',
      'Anthropology and Development Studies'
    ],
    'Migratie & Multiculturele Samenlevingen': [
      'Migration, Ethnic Relations and Multiculturalism'
    ],
    'Toegepaste Sociale Wetenschappen & Organisatiepsychologie': [
      'International Joint Master of Research in Work and Organizational Psychology'
    ],
    'Vrije Tijd, Toerisme & Samenleving': [
      'Leisure and Tourism Studies',
      'Tourism, Society and Environment'
    ],
    'Onderzoeksmethoden & Statistiek': [
      'Methodology and Statistics for the Behavioural, Biomedical and Social Sciences'
    ]
  },
  'Recht & Bestuur': {
    'Algemeen Recht & Rechtsgeleerdheid': [
      'Nederlands recht',
      'Rechtsgeleerdheid',
      'Privaatrecht',
      'Publiekrecht',
      'Rechtwetenschappelijk Onderzoek'
    ],
    'Internationaal & Europees Recht': [
      'International Laws',
      'International and European Law',
      'International Business Law',
      'International Commercial Law',
      'Globalisation and Law',
      'European Private Law',
      'European Law in a Global Context',
      'Public International Law',
      'International Tax Law',
      'International and European Tax Law',
      'Advanced Studies in International Civil and Commercial Law',
      'Advanced Studies in Public International Law',
      'Advanced Studies in European and International Business Law',
      'Advanced Studies in European and International Human Rights Law'
    ],
    'Ondernemingsrecht & Financieel Recht': [
      'Ondernemingsrecht',
      'Onderneming en recht',
      'Commercial Law',
      'Advanced Studies in Law and Finance',
      'Law and Economics'
    ],
    'Arbeidsrecht & Sociaal Recht': [
      'Arbeidsrecht',
      'Recht en Arbeid',
      'Sociaal Recht en Sociale Politiek'
    ],
    'Fiscaal & Notarieel Recht': [
      'Fiscaal Recht',
      'Notarieel Recht'
    ],
    'Technologie, Privacy & Intellectueel Eigendom': [
      'Law and Technology',
      'IT-recht',
      'Advanced Master Intellectual Property Law and Knowledge Management LL.M.',
      'Advanced Studies in Law and Digital Technologies',
      'Gegevensbescherming en Privacyrecht'
    ],
    'Klimaat-, Energie- & Ruimterecht': [
      'Energy and Climate Law',
      'Advanced Master in Energy Law',
      'Advanced Studies in Air and Space Law'
    ],
    'Strafrecht, Criminologie & Veiligheid': [
      'Criminologie',
      'Forensische Criminologie',
      'Global Criminal Law',
      'International Criminal Law',
      'International Crimes, Conflict and Criminology',
      'Criminaliteit en Rechtshandhaving',
      'Forensica, Criminologie en Rechtspleging',
      'Law and Politics of International Security'
    ],
    'Bestuurskunde & Openbaar Bestuur': [
      'Bestuurskunde',
      'Public Administration',
      'Recht en Bestuur',
      'Publiek Management',
      'Management Publieke Sector',
      'Executive Master of Public and Non-profit Management',
      'Research in Public Administration and Organizational Science'
    ],
    'Beleid & Organisatie': [
      'Public Policy and Human Development',
      'Erasmus Mundus Master\'s Program in Public Policy',
      'International Public Management and Public Policy',
      'Conflict Resolution and Governance',
      'Beleid, Communicatie en Organisatie',
      'Sustainability Science, Policy and Society',
      'Governance of Sustainability',
      'Organization and Management Studies'
    ],
    'Internationale Betrekkingen & Diplomatie': [
      'Internationale betrekkingen',
      'International Relations and Diplomacy'
    ],
    'Specialisaties in Recht': [
      'Advanced Studies in International Children\'s Rights',
      'Advanced Studies in International Dispute Settlement and Arbitration',
      'Advanced LLM in Technology Governance',
      'Mater of Science in Policing',
      'Togamaster',
      'Jeugdrecht',
      'Aansprakelijkheid en verzekering'
    ],
    'Management & Leiderschap binnen Recht en Bestuur': [
      'Executive Master of Management and Organization',
      'Executive Master of Management in Education'
    ]
  }
};

// Studie categorieën en studies met uitgebreide voorbeelden
export const STUDIE_CATEGORIEEN = {
  'Techniek': [
    'Informatica',
    'Elektrotechniek',
    'Werktuigbouwkunde',
    'Bouwkunde',
    'Industrieel Ontwerpen',
    'Technische Bedrijfskunde',
    'Mechatronica',
    'Chemische Technologie'
  ],
  'Zorg & Welzijn': [
    'Verpleegkunde',
    'Fysiotherapie',
    'Social Work',
    'Toegepaste Psychologie',
    'Ergotherapie',
    'Logopedie',
    'Voeding & Diëtetiek',
    'Gezondheidswetenschappen'
  ],
  'Economie': [
    'Bedrijfskunde',
    'Commerciële Economie',
    'Finance & Control',
    'International Business',
    'Economie & Bedrijfseconomie',
    'Marketing Management',
    'Human Resource Management',
    'Logistiek & Supply Chain'
  ],
  'Onderwijs': [
    'PABO',
    'Lerarenopleiding VO',
    'Pedagogiek',
    'Onderwijskunde',
    'Lerarenopleiding MBO',
    'Educatie & Communicatie'
  ],
  'Recht & Bestuur': [
    'Rechtsgeleerdheid',
    'Bestuurskunde',
    'Criminologie',
    'Internationale Betrekkingen',
    'Politicologie',
    'Europees Recht'
  ],
  'Kunst & Media': [
    'Kunstacademie',
    'Journalistiek',
    'Communicatie',
    'Media & Entertainment',
    'Grafisch Ontwerp',
    'Film & Televisie'
  ],
  'Natuur & Milieu': [
    'Biologie',
    'Chemie',
    'Aardwetenschappen',
    'Milieuwetenschappen',
    'Duurzame Ontwikkeling',
    'Klimaat & Energie'
  ]
};

// Uren opties
export const UREN_OPties = [
  '0–8 uur',
  '8–16 uur',
  '16–24 uur',
  '24–32 uur',
  '32–40 uur',
  '40+ uur'
];

// Progress steps
export const PROGRESS_STEPS = [
  { id: 1, label: 'Introductie' },
  { id: 2, label: 'Wat wil je plaatsen?' },
  { id: 3, label: 'Bedrijfsinformatie' },
  { id: 4, label: 'Studiegegevens' },
  { id: 5, label: 'Vereisten & Voordelen' },
  { id: 6, label: 'Vergoeding' },
  { id: 7, label: 'Locatie & Doorgroei' }
]; 